/* src/app/admin-dashboard/orders/refund-reason-dialog/refund-reason-dialog.component.css */
.full-width {
  width: 100%;
}
.custom-textarea {
  margin-top: 20px;
}
.custom-textarea textarea {
  padding-top: 12px;
  min-height: 100px;
}
button.theme-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
.reason-section {
  margin-bottom: 1rem;
}
.reason-section .mat-form-field {
  width: 100%;
}
.reason-section .mat-form-field textarea {
  resize: vertical;
  min-height: 100px;
  padding: 10px;
  font-size: 14px;
}
/*# sourceMappingURL=refund-reason-dialog.component.css.map */
